var map = {
	"./1822direkt.jpg": 789,
	"./CoinTracking_square.png": 790,
	"./abmamro.png": 791,
	"./aktienfreunde.png": 792,
	"./baaderbank.png": 793,
	"./bawag.jpg": 794,
	"./bethmann.png": 795,
	"./binance.png": 796,
	"./bison.png": 797,
	"./bitpanda.png": 798,
	"./captrader.png": 799,
	"./coinbase.png": 800,
	"./comdirect.png": 801,
	"./commerzbank.jpg": 802,
	"./consors.jpg": 803,
	"./cortalconsors.jpg": 804,
	"./degiro.png": 805,
	"./deutschebank.png": 806,
	"./divvy.png": 807,
	"./dkb.png": 808,
	"./easybank.png": 809,
	"./ebase.png": 810,
	"./erstebank.png": 811,
	"./extraetf.png": 812,
	"./ffb.png": 813,
	"./finanzennet.png": 814,
	"./flatex.png": 815,
	"./fondsdepotbank.png": 816,
	"./gls.png": 817,
	"./haspa.png": 818,
	"./hypovereinsbank.png": 819,
	"./ingdiba.png": 820,
	"./interactivebrokers.png": 821,
	"./justtrade.png": 822,
	"./morgenfund.png": 823,
	"./mydividends24.png": 824,
	"./nextmarket-logo.png": 825,
	"./onvista.png": 826,
	"./peaks.png": 827,
	"./portfolioperformance.png": 828,
	"./postbank.png": 829,
	"./quirion.jpg": 830,
	"./sbroker.png": 831,
	"./scalable.jpg": 832,
	"./smartbroker.png": 833,
	"./swissquote.jpg": 834,
	"./targobank.png": 835,
	"./traderepublic.png": 836,
	"./trading212.png": 837,
	"./unioninvest.png": 838,
	"./vrbank.png": 839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;